import MonthlySaleReportPage from "./MonthlySaleReportPage";

/**
 * Same Monthly Sale Report layout as /reports/monthly-sale-report,
 * but data comes only from Firestore `sales_import_months` lineChunks
 * (no manual upload merges, no Credit/Due supplements).
 */
export default function MonthlySaleReportImportPage() {
  return <MonthlySaleReportPage importOnly hideUpload />;
}
